module.exports = __webpack_public_path__ + "img/MSuite-mau.c68e598e.svg";